module.exports = __webpack_public_path__ + "static/media/zl_2_18.2f7c4394.png";